import p1 from "./assets/p(1).jpg";
import p2 from "./assets/p(2).jpg";
import p3 from "./assets/p(3).jpg";
import p4 from "./assets/p(4).jpg";
import p5 from "./assets/p(5).jpg";
import p6 from "./assets/p(6).jpg";

// ---------------------------------

import g1 from "./assets/g(1).jpg";
import g2 from "./assets/g(2).jpg";
import g3 from "./assets/g(3).jpg";
import g4 from "./assets/g(4).jpg";
import g5 from "./assets/g(5).jpg";
import g6 from "./assets/g(6).jpg";
import g7 from "./assets/g(7).jpg";
import g8 from "./assets/g(8).jpg";
import g9 from "./assets/g(9).jpg";

// ----------------------------------

import pic1 from "./assets/pic-1.png";
import pic2 from "./assets/pic-2.png";
import pic3 from "./assets/pic-3.png";
import pic4 from "./assets/pic-4.png";
import pic5 from "./assets/pic-5.jpg";
import pic6 from "./assets/pic-6.jpg";

export const packageData = [
  {
    image: p1,
    place: "Agra",
    desc: "Sed ut perspiciatis unde omnis iste natus error sit voluptatem !!!",
    price: "$5k",
    prevPrice: "$6k",
  },
  {
    image: p2,
    place: "cairo",
    desc: "Sed ut perspiciatis unde omnis iste natus error sit voluptatem !!!",
    price: "$7.5k",
    prevPrice: "$9k",
  },
  {
    image: p3,
    place: "Lahore",
    desc: "Sed ut perspiciatis unde omnis iste natus error sit voluptatem !!!",
    price: "$5.2k",
    prevPrice: "$7.5k",
  },
  {
    image: p4,
    place: "Paris",
    desc: "Sed ut perspiciatis unde omnis iste natus error sit voluptatem !!!",
    price: "$9k",
    prevPrice: "$12k",
  },
  {
    image: p5,
    place: "Rome",
    desc: "Sed ut perspiciatis unde omnis iste natus error sit voluptatem !!!",
    price: "$8k",
    prevPrice: "$10k",
  },
  {
    image: p6,
    place: "Capetown",
    desc: "Sed ut perspiciatis unde omnis iste natus error sit voluptatem !!!",
    price: "$7.3k",
    prevPrice: "$8.6k",
  },
];

export const servicesData = [
  {
    icon: "fas fa-hotel",
    title: "Affordable hotels",
    desc: "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas.",
  },
  {
    icon: "fas fa-utensils",
    title: "food and drinks",
    desc: "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas.",
  },
  {
    icon: "fas fa-bullhorn",
    title: "safety guide",
    desc: "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas.",
  },

  {
    icon: "fas fa-globe-asia",
    title: "Around the world",
    desc: "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas.",
  },

  {
    icon: "fas fa-plane",
    title: "fastest travel",
    desc: "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas.",
  },
  {
    icon: "fas fa-hiking",
    title: "Adventures",
    desc: "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas.",
  },
];

export const galleryData = [
  {
    image: g1,
    title: "amazing places",
    desc: "Et harum quidem rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est.",
  },
  {
    image: g2,
    title: "amazing places",
    desc: "Et harum quidem rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est.",
  },
  {
    image: g3,
    title: "amazing places",
    desc: "Et harum quidem rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est.",
  },
  {
    image: g4,
    title: "amazing places",
    desc: "Et harum quidem rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est.",
  },
  {
    image: g5,
    title: "amazing places",
    desc: "Et harum quidem rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est.",
  },
  {
    image: g6,
    title: "amazing places",
    desc: "Et harum quidem rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est.",
  },
  {
    image: g7,
    title: "amazing places",
    desc: "Et harum quidem rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est.",
  },
  {
    image: g8,
    title: "amazing places",
    desc: "Et harum quidem rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est.",
  },
  {
    image: g9,
    title: "amazing places",
    desc: "Et harum quidem rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est.",
  },
];

export const reviewData = [
  {
    image: pic1,
    person: "John Doe",
    speech:
      "excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
  },
  {
    image: pic2,
    person: "Jane Doe",
    speech:
      "excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
  },
  {
    image: pic3,
    person: "Martin Cooper",
    speech:
      "excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
  },
  {
    image: pic4,
    person: "Linda Caroll",
    speech:
      "excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
  },
  {
    image: pic5,
    person: "Robert Parkinson",
    speech:
      "excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
  },

  {
    image: pic6,
    person: "Makhaya Ntini",
    speech:
      "excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
  },
];
